import angular from 'angular';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.maintenance').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.maintenanceReports, {
    url: '/reports',
    params: { title: 'Maintenance - Reports' },
    views: {
      childcontent: {
        templateUrl:
          'Client/runner.maintenance/reports/runner.maintenance.reports.tmpl.html',
        controllerAs: '$ctrl',
        controller: 'maintenanceReportsController'
      }
    }
  });
}
